<template>
  <BaseDataIterator nested :items="funnels" :service="fetchFunnels" disable-search>
    <template #custom-actions="{ queryContext }">
      <FunnelCreateAction :account-id="accountId" :on-created="queryContext.actions.execute" />
    </template>
    <template #default="{ data }">
      <div class="p-4 bg-gray-100">
        <BaseGrid :columns="4" class="gap-4">
          <FunnelCard v-for="funnel in data" :key="funnel.id" :funnel="funnel" />
        </BaseGrid>
      </div>
    </template>
  </BaseDataIterator>
</template>

<script>
import { accountFunnelsClient } from '@/api/clients';
import { merge } from 'lodash-es';
import FunnelCard from './FunnelCard.vue';
import FunnelCreateAction from './funnel-create-action.vue';

export default {
  components: {
    FunnelCard,
    FunnelCreateAction,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    funnelCategoryId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      funnels: [],
    };
  },
  computed: {
    account() {
      return this.$store.state.entities.accounts.byId[this.accountId];
    },
  },
  methods: {
    resetList() {
      this.$refs.dataList.resetList();
    },
    refreshList() {
      this.$refs.dataList.fetchList();
    },
    async fetchFunnels(params = {}) {
      try {
        const response = await accountFunnelsClient.list(this.accountId, {
          ...params,
          ...(this.funnelCategoryId
            ? {
                filter: {
                  funnel_category_id: this.funnelCategoryId,
                },
              }
            : {}),
          include: ['stages.audiences.model', 'stages.average_audience_count'],
        });

        this.funnels = response.data;

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    updateFunnel(newFunnel) {
      this.funnels = this.funnels.map((funnel) => {
        if (funnel.id !== newFunnel.id) {
          return funnel;
        }

        return merge(funnel, newFunnel);
      });
    },
  },
};
</script>
